//
//
//
//
//

export default {
  props: { // 接受父组件传递的值，用来控制图形验证的加载
    isGeet: {
      type: Boolean, default: false
    },
    width: {
      type: [Number, String], default: 310
    },
    product: {
      type: String, default: 'popup'
    }
  },
  data () {
    return {
      isPopGeet: false,
      lanGeet: {
        zh: 'zho-tw',
        en: 'eng',
        'zh-cn': 'zho',
        ja: 'jpn',
        id: 'ind',
        ko: 'kor',
        ru: 'rus',
        ar: 'ara',
        pt: 'por',
        fr: 'fra',
        de: 'deu'
      }
    }
  },
  watch: {
    // 监听参数的变化，调用极验
    isGeet (newV) {
      if (!newV || this.isPopGeet) return false
      this.$nextTick(() => {
        this.isPopGeet = true
        const that = this
        setTimeout(() => {
          that.isPopGeet = false
        }, 1500)
        this.getcaptchaid()
        this.$refs.btn.click() // 这里通过按钮事件调用极验
      })
    }
  },
  methods: {
    // async gtCaptcha () {
    //   try {
    //     const { succeed = true, result = {} } = await this.$api.login.userPhone({ clienttype: 'web' })
    //     if (succeed) this.initvify(result)
    //   } catch (err) {}
    // },
    updateIsGeet () {
      this.getcaptchaid()
    },
    gtCaptcha () {
      this.getcaptchaid()
    },

    async getcaptchaid () {
      console.log(this.$store.state.phoneInfo.code)
      const res = await this.$api.common
        .v3Client(
          {
            Routes: 'usercenter$getcaptchaid'
          }, {
            areaCode: this.$store.state.phoneInfo.code
          })
        .catch(() => {
          console.log('获取极验id')
        })
      if (res.usercenter.getcaptchaid.data) {
        this.initvify(res.usercenter.getcaptchaid.data)
      } else {
        console.log('极验id获取失败')
      }
    },

    initvify (id) {
      const that = this
      this.$initGeet(
        {
          captchaId: id, // gt,
          product: this.product,
          language: this.getGeetLanguge()
        },
        (captchaObj) => {
          this.geetest = captchaObj
          captchaObj.appendTo('#huakuai')
          captchaObj
            .onReady(() => {
              // 验证码ready之后才能调用verify方法显示验证码(可以显示窗口了)
              if (this.product == 'bind') captchaObj.showCaptcha() // 显示验证码窗口
              captchaObj.onClose(function () {
                // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
                that.$emit('closeGeet')
              })
            })
            .onSuccess(() => {
              this.isPopGeet = false
              console.log('captchaObj.getValidate(): ', captchaObj.getValidate())
              this.$emit('geetPath', captchaObj.getValidate())
            })
            .onError(() => {
              this.isPopGeet = false
              this.$emit('geetError')
              console.log('极验错误')
              captchaObj.destroy()
            })
        }
      )
    },

    getGeetLanguge () {
      const language = this.$store.state.locale
      let geetlan = language == 'zh' ? 'zho-tw' : language == 'zh-cn' ? 'zh-cn' : ''
      if (this.lanGeet && !geetlan) {
        const geetLanArr = Object.keys(this.lanGeet)
        geetLanArr.forEach((it) => {
          if (it == language) {
            geetlan = this.lanGeet[it]
          }
        })
      }
      return geetlan || 'en'
    }
  }
}
